import React, { lazy } from 'react';

export const FORCE_REFRESH_NOTIFIER = 'showForceRefreshNotifier';
export const FORCE_REFRESH_SECONDS = 5;

class DummyComponent extends React.Component {
  render() {
    return <></>
  }
}

const reloadWithDelay = (delay = FORCE_REFRESH_SECONDS) =>
  new Promise((resolve) => {
    setTimeout(() => {
      // reload page
      resolve(window.location.reload());
    }, delay * 1000);
  });

export const lazyWithRetry = (importFunction) =>
  lazy(async () => {
    // get refresh flag from session storage
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.sessionStorage.getItem(
        'page-has-been-force-refreshed'
      ) || 'false'
    );
    try {
      const component = await importFunction();
      // set refresh flag to false once component is imported
      window.sessionStorage.setItem(
        'page-has-been-force-refreshed',
        'false'
      );
      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is NOT on the latest version of the application.
        window.sessionStorage.setItem(
          'page-has-been-force-refreshed',
          'true'
        );
        // Notify the main app to show notification if needed
        window.postMessage(FORCE_REFRESH_NOTIFIER, window.location.origin);
        // Let's refresh the page immediately.
        await reloadWithDelay();
        return { default: DummyComponent };
      }
      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  });

export default lazyWithRetry;
